import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Search from './Search/index.js';
import Header from './Header/index.js';
import Cart from './Cart/index.js';
import Blog from './Blog/index.js';
import Toast from './Toast/index.js';
import PopinNewsletter from './PopinNewsletter.js';
import ProductInfo from './ProductInfo/index.js';
import Product from './Product/index.js';
import LanguageModal from './LanguageModal.js';
import Video from './Video.js';
import Facets from './Facets/index.js';

/**
 * Shop component
 */
export default class Shop extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Shop',
    components: {
      PopinNewsletter,
      Header,
      Product,
      Cart,
      Search,
      Blog,
      Toast,
      ProductInfo,
      LanguageModal,
      Video,
      FormEndpoint: (app) =>
        importWhenVisible(() => import('./FormEndpoint.js'), 'FormEndpoint', app),
      Facets,
      Readmore: (app) => importWhenVisible(() => import('./Readmore.js'), 'Readmore', app),
      VariantMedia: (app) =>
        importWhenVisible(() => import('./VariantMedia.js'), 'VariantMedia', app),
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }
}
